import React, { FC, ReactNode } from 'react';
import clsx from 'classnames';

import { IconNameType } from '@app/components/ui/icons/icon-name.type';
import Icon from '@app/components/ui/icons';
import classNames from 'classnames';
import { ArrowLeftIcon } from '@app/components/ui/icons/icons-list';
import { CircleButton } from '@ui';
import { useNavigate } from 'react-router-dom';
import { To } from 'history';

type PageHeaderProps = {
  icon?: IconNameType;
  label: string | ReactNode;
  after?: IconNameType;
  afterAction?: () => void;
  popLink?: string | number;
  popLinkVoid?: () => void;
  children?: ReactNode;
  customClassName?: string;
  childIsFull?: boolean;
};
const PageHeader: FC<PageHeaderProps> = (props) => {
  const {
    icon,
    children,
    popLinkVoid,
    childIsFull,
    label,
    after,
    popLink,
    afterAction,
    customClassName,
  } = props;
  const navigate = useNavigate();
  const circleButtonClassName = classNames(
    'w-[32px]',
    'h-[32px]',
    'bg-speech_analitics',
    'text-white',
    'inline-flex',
    'justify-center',
    'transition',
    'hover:opacity-80',
    'items-center',
    'rounded-full',
    'mr-[16px]',
  );

  const renderIconPageHeader = icon && (
    <Icon name={icon} size={26} className="text-speech_analitics_middle mr-[16px]" />
  );

  const renderAfterAction = after && (
    <div className="ml-[5px] mt-[5px]">
      <CircleButton
        icon={after}
        size={22}
        className="text-action"
        onClick={afterAction?.bind(null)}
      />
    </div>
  );

  const renderBackButton = popLink && (
    <div className="ml-[-10px]">
      <button onClick={() => navigate(popLink as To)} className={circleButtonClassName}>
        <ArrowLeftIcon size={19} className="text-white" />
      </button>
    </div>
  );
  const renderBackButtonWithVoid = popLinkVoid && (
    <div className="ml-[-10px]">
      <button onClick={popLinkVoid} className={circleButtonClassName}>
        <ArrowLeftIcon size={19} className="text-white" />
      </button>
    </div>
  );

  return (
    <div
      className={clsx(
        popLink ? 'pt-[32px] pb-[25px]' : 'pt-[22px] pb-[20px]',
        `${
          customClassName ? customClassName : 'inline-flex items-center justify-between'
        } pl-[10px] w-full min-h-[85px]`,
      )}
    >
      <div className="inline-flex h-full items-center">
        {renderBackButton}
        {renderBackButtonWithVoid}
        {renderIconPageHeader}
        <div
          className={`${
            childIsFull && 'w-full whitespace-nowrap'
          }  font-[700] text-[24px] text-1color inline-flex items-center z-[1]`}
        >
          {label}
        </div>
        {renderAfterAction}
      </div>
      <div className={`${childIsFull && 'w-full'} h-full inline-flex items-center`}>{children}</div>
    </div>
  );
};

export default PageHeader;
